<template>
  <MyAccount></MyAccount>
</template>

<script>
// @ is an alias to /src
import MyAccount from "@/components/MyAccount.vue";
export default {
  name: "MyAccountView",
  components: { MyAccount }
};
</script>
